module.exports = __webpack_public_path__ + "static/media/photo_011.5ad9a0f4.JPG";